module.exports = __webpack_public_path__ + "static/media/h2.c211fa02.jpeg";